export default __webpack_public_path__ + "static/media/turnoLogo.184a4eed.svg";